module.exports = __webpack_public_path__ + "static/media/bg.84fa8b45.png";